import axios from '@/libs/api.request'

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'financeManage/rechargePending/index',
    method: 'get',
    params: params
  })
}

/**
 * 删除数据
 */
export const del = (id) => {
  return axios.request({
    url: 'financeManage/rechargePending/del',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 锁定/解锁
 */
export const lock = (id) => {
  return axios.request({
    url: 'financeManage/rechargePending/lock',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * changeIsAutoWithdraw
 */
export const changeIsAutoRecharge = (is_auto_recharge) => {
  return axios.request({
    url: 'financeManage/rechargePending/changeIsAutoRecharge',
    method: 'get',
    params: {
      is_auto_recharge: is_auto_recharge
    }
  })
}

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getWindowsParams = () => {
  return axios.request({
    url: 'financeManage/rechargePending/getWindowsParams',
    method: 'get'
  })
}

/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const changeStatus = (status, id) => {
  return axios.request({
    url: 'financeManage/rechargePending/changeStatus',
    method: 'get',
    params: {
      status: status,
      id: id
    }
  })
}

/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const changeSend = (data) => {
  return axios.request({
    url: 'financeManage/rechargePending/changeSend',
    method: 'post',
    data
  })
}

/**
 * 编辑
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const edit = (data) => {
  return axios.request({
    url: 'financeManage/rechargePending/edit',
    method: 'post',
    data
  })
}
